export const defaultsV96 = {
  enabled: false,
  models: [],
  endpoint: '',
  model: '',
  source_size: '1024x1024',
  transport: 'base64',
  failure_mode: 'required',
  timeout_seconds: 120,
  prices_nano_usd: {},
};

export function priceRowsV96(up = {}) {
  return (
    up.price_rows ??
    Object.entries(up.prices_nano_usd || {}).map(([target, nanos]) => ({
      target,
      usd: (nanos / 1e9).toFixed(9).replace(/\.?0+$/, ''),
    }))
  );
}

export function usdToNanosV96(value) {
  const text = String(value).trim();
  if (!/^(0|[1-9]\d*)(\.\d{1,9})?$/.test(text)) {
    throw new Error('upscaling_v96.invalid_price');
  }
  const [whole, fraction = ''] = text.split('.');
  const nanos = Number(whole) * 1e9 + Number(fraction.padEnd(9, '0'));
  if (!Number.isSafeInteger(nanos) || nanos < 0 || nanos > 1e12) {
    throw new Error('upscaling_v96.invalid_price');
  }
  return nanos;
}

export function buildUpscalingConfigV96(config) {
  if (!config.upscaling_v96) return config;
  const up = { ...defaultsV96, ...config.upscaling_v96 };
  const prices = {};
  for (const row of priceRowsV96(up)) {
    const target = row.target.trim().toUpperCase().replace('X', 'x');
    const parts = target.split('x').map(Number);
    const valid =
      ['4K', '8K'].includes(target) ||
      (/^[1-9]\d*x[1-9]\d*$/.test(target) &&
        parts.every((n) => n <= 8192) &&
        parts[0] * parts[1] <= 64000000);
    if (!valid || Object.prototype.hasOwnProperty.call(prices, target)) {
      throw new Error('upscaling_v96.invalid_target');
    }
    prices[target] = usdToNanosV96(row.usd);
  }
  if (up.enabled && (!up.models.length || !Object.keys(prices).length)) {
    throw new Error('upscaling_v96.missing');
  }
  delete up.price_rows;
  return {
    ...config,
    upscaling_v96: {
      ...up,
      timeout_seconds: Number(up.timeout_seconds),
      prices_nano_usd: prices,
    },
  };
}

export function preserveUpscalingOnRevealV96(current, revealed) {
  return {
    ...revealed,
    ...(current.upscaling_v96 !== undefined
      ? { upscaling_v96: current.upscaling_v96 }
      : {}),
    ...(current.upscale_api_key_v96
      ? { upscale_api_key_v96: current.upscale_api_key_v96 }
      : {}),
  };
}
